import axios from 'axios';
import { showSuccessNotification, showErrorNotification } from "actions/action-complete-notificator";

export const CHANGE_USER_PASSWORD_PENDING = 'CHANGE_USER_PASSWORD_PENDING';
export const CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS';
export const CHANGE_USER_PASSWORD_ERROR = 'CHANGE_USER_PASSWORD_ERROR';

function changeUserPasswordPending() {
    return {
        type: CHANGE_USER_PASSWORD_PENDING
    }
}

function changeUserPasswordSuccess(currentUser, translations) {
    showSuccessNotification(translations.passwordChanged);
    return {
        type: CHANGE_USER_PASSWORD_SUCCESS,
        currentUser: currentUser
    }
}

function changeUserPasswordError(error) {
    showErrorNotification(error.response);
    return {
        type: CHANGE_USER_PASSWORD_ERROR,
        error: error
    }
}

function changeUserPasswordAction(data, translations) {
    axios.defaults.baseURL = window.location.origin;
    axios.defaults.withCredentials = true;
    var url = '/api/User/UpdatePassword';
    return dispatch => {
        dispatch(changeUserPasswordPending());
        axios.post(url, data, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(changeUserPasswordSuccess(res, translations));
            })
            .catch(error => {
                dispatch(changeUserPasswordError(error));
            })
    }
}

export default changeUserPasswordAction;
